import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Body2 } from "@activecollab/components";
import PropTypes from "prop-types";
import { fetchTaskLists } from "~/store/actions/actions.taskLists.jsx";
import { getAllTaskListsArrayByProjectId } from "~/store/selectors/selector.taskLists.jsx";
import SelectTaskList from "../SelectTaskList.js";

const ProjectTaskListSelectContainer = ({ canEdit, projectId, selectedId, onChange }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const allTaskLists = useSelector((state) => getAllTaskListsArrayByProjectId(state, projectId));

  const taskListOptions = useMemo(() => {
    return allTaskLists.filter(
      (taskList) => (!taskList.isCompleted && !taskList.isTrashed) || taskList.id === selectedId
    );
  }, [allTaskLists, selectedId]);

  useEffect(() => {
    dispatch(fetchTaskLists(projectId));
  }, [dispatch, projectId]);

  const selectedIdName = useMemo(() => {
    const notSet = t("Not Set");

    if (selectedId > 0) {
      const taskList = allTaskLists.find(({ id }) => id === selectedId);
      return taskList && taskList.name ? taskList.name : notSet;
    }

    return notSet;
  }, [t, selectedId, allTaskLists]);

  return canEdit ? (
    <SelectTaskList
      projectId={projectId}
      selected={selectedId}
      options={taskListOptions}
      onChange={onChange}
    />
  ) : (
    <Body2 color="secondary">{selectedIdName}</Body2>
  );
};

ProjectTaskListSelectContainer.propTypes = {
  canEdit: PropTypes.bool,
  projectId: PropTypes.number.isRequired,
  selectedId: PropTypes.number,
  onChange: PropTypes.func,
};

ProjectTaskListSelectContainer.defaultProps = {
  canEdit: false,
  selectedId: 0,
  onChange: () => {},
};

export default ProjectTaskListSelectContainer;
